import { render, staticRenderFns } from "./expenssList.vue?vue&type=template&id=dca0c154&scoped=true&"
import script from "./expenssList.vue?vue&type=script&lang=js&"
export * from "./expenssList.vue?vue&type=script&lang=js&"
import style0 from "./expenssList.vue?vue&type=style&index=0&id=dca0c154&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca0c154",
  null
  
)

export default component.exports